import healthSafetyProgramVideo from '../data/Part1_TODV Health and Safety Program Manual Orientation 2025-01.mp4';
import whmisTrainingVideo from '../data/Part2_TODV WHMIS Training 2023-05.mp4';
import harassmentViolenceVideo from '../data/Part3_TODV Harassment_Violence Policy Review 2025-01.mp4';
import { isDemoMode } from '../utils/runtimeMode';

export const getOrientationVideoSources = () => {
  if (!isDemoMode()) {
    return {
      healthSafetyProgramVideo,
      whmisTrainingVideo,
      harassmentViolenceVideo
    };
  }

  return {
    healthSafetyProgramVideo: process.env.REACT_APP_DEMO_HEALTH_SAFETY_VIDEO_URL || healthSafetyProgramVideo,
    whmisTrainingVideo: process.env.REACT_APP_DEMO_WHMIS_VIDEO_URL || whmisTrainingVideo,
    harassmentViolenceVideo: process.env.REACT_APP_DEMO_HARASSMENT_VIDEO_URL || harassmentViolenceVideo
  };
};